export default __webpack_public_path__ + "static/jelmyto-logo-550e7008df614fc07ff398016da6b663.png";